export default __webpack_public_path__ + "static/media/egg3.9c598c60.jpg";